<template>
  <w-flex v-if="projectNameAndVersion" class="app-version" justify="center">
    {{ projectNameAndVersion }}
  </w-flex>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  version?: string;
  projectName?: string;
}>();

const projectNameAndVersion = computed(() =>
  [props.projectName, props.version].filter(Boolean).join(' / '),
);
</script>

<style lang="scss">
.app-version {
  color: w.color('neutral', 300);
  font-size: w.font('xxsmall');
  text-align: center;
  letter-spacing: 0.1em;
  padding-top: 2px;
  padding-bottom: 2px;
}
</style>
